module.exports = __webpack_public_path__ + "img/cover-artikel-2.b0389aad.png";